module.exports = __webpack_public_path__ + "static/media/28DGC9.52bfa2d6.jpg";